
import React from 'react';

const FAQSection: React.FC = () => {
  const faqs = [
    {
      question: 'Do you offer same-day service?',
      answer: 'Yes, we offer same-day service for urgent issues based on availability. For non-emergency needs, we typically schedule appointments within 24-48 hours.'
    },
    {
      question: 'Can you help with both PC and Mac computers?',
      answer: 'Absolutely! Our technicians are certified in both Windows and Mac operating systems and can assist with any brand of computer or device.'
    },
    {
      question: 'How do you charge for residential services?',
      answer: 'We offer flexible payment options including hourly rates, fixed-price service packages, and monthly subscription plans to fit your needs and budget.'
    },
    {
      question: 'Is my data safe during repairs?',
      answer: 'Yes, protecting your data is our top priority. We follow strict privacy protocols, and our technicians are trained in handling sensitive information securely.'
    },
    {
      question: 'Do you offer ongoing support after the initial service?',
      answer: 'Yes, we provide follow-up support after service completion and offer subscription plans for households that need regular ongoing support for their technology.'
    }
  ];

  return (
    <section className="section-padding bg-gray-50">
      <div className="container-wide">
        <div className="text-center mb-12">
          <h2 className="heading-lg text-itmgmt-dark-blue mb-4">Frequently Asked Questions</h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Common questions about our residential IT services
          </p>
        </div>
        
        <div className="max-w-3xl mx-auto divide-y divide-gray-200">
          {faqs.map((faq, index) => (
            <div key={index} className="py-5">
              <h3 className="text-lg font-semibold text-itmgmt-dark-blue mb-2">{faq.question}</h3>
              <p className="text-gray-600">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
